import { useState } from 'react'
import Navbar from './Components/Navbar/Navbar.jsx';
import Index from './Components/Page/Index.jsx';

function App() {
  
  return (
    <>
      <Navbar/>
      <Index/>
    </>
  )
}

export default App